/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* Warenkorb-Symbol im Header direkt zur Warenkorbseite führen */
(function () {
  function redirectHeaderCartClick(event) {
    var clickedElement = event.target;

    if (!(clickedElement instanceof Element)) {
      return;
    }

    var header = clickedElement.closest(
      'header, .header, .shopify-section--header, #shopify-section-header'
    );

    if (!header) {
      return;
    }

    var cartTrigger = clickedElement.closest(
      [
        '[data-action="toggle-mini-cart"]',
        '[aria-controls="mini-cart"]',
        '.header__cart-toggle',
        '.header__action-item--cart a',
        '.header__action-item--cart button',
        'a[href="/cart"]',
        'a[href$="/cart"]'
      ].join(',')
    );

    if (!cartTrigger) {
      return;
    }

    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();

    window.location.assign('/cart');
  }

  window.addEventListener('click', redirectHeaderCartClick, true);
  })();

  